import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Avvio
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_145
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux;
            aux = thn.dataLayerHelper.get('language');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = window.location.pathname.match(ctx.urlRe);
            aux = aux && aux.length && aux[1];
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = document.documentElement.lang;
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            aux = document.querySelector('a[href*="toggleMenuOption(\'language\')"]')?.textContent?.trim().toLowerCase();
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_145
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        /* EXAMPLE URL :
        https://secure.springfieldhotel.ie/convert/site/Springfield%20Hotel/en/results.php?checkin=2024-06-19&nights=1&currency=EUR&resultViewType=mda&viewtype=rateroom&partya=1
        */
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.match(/secure|avvio/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * @memberOf module:bs_145
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(_ctx) {
        const container = document.querySelector('#section_mainpage');
        if (container) {
            const avvioUpdater = thn.debounce(() => {
                thn.widgets.price.update();
            }, 300);
            thn.observeDom(container, avvioUpdater);
            thn.pageUnload(() => {
                thn.stopObserveDom(container, avvioUpdater);
            });
        }
    };
    engine.onStateChange = thn.debounce(function (ctx) {
        thn.pageCheck();
    }, 800);
    /**
       * @memberOf module:bs_145
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        //* Dates
        widgetData.nights = 0;
        const startDate = (document.querySelector('#checkin_new_hidden')?.value || '').replace(/-/g, '/');
        const dateBegin = thn.parseUrlParameter('checkin') || thn.parseUrlParameter('start');
        const nights = thn.parseUrlParameter('nights');
        if (startDate) {
            widgetData.dateBegin = startDate;
            /* 2018-10-04 - New BE implementation */
            widgetData.nights = parseInt(thn.parseNumber(document.querySelector('#nights_new')?.value), 10)
                || parseInt(document.querySelector('#nights')?.value, 10);
            widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));
        }
        else if (dateBegin && nights) {
            // Get from URL
            widgetData.dateBegin = dateBegin.replace(/-/g, '/');
            widgetData.nights = parseInt(nights, 10);
            widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, widgetData.nights));
        }
        else {
            // Get from DOM
            widgetData.dateBegin = thn.dateToString(document.querySelector('.top-filter-dates-checkin .top-filter-dates-date')?.textContent);
            widgetData.dateEnd = thn.dateToString(document.querySelector('.top-filter-dates-checkout .top-filter-dates-date')?.textContent);
            if (widgetData.dateBegin && widgetData.dateEnd) {
                widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
            }
        }
        //* Currency
        widgetData.currency = document.querySelector('#currency')?.value;
        if (document.querySelector('.multiroombutton')) { //* (Multi Room Occupancy)
            const multiRoomElements = [...document.querySelectorAll('.resultsection[id*=rate_]')];
            const prices = multiRoomElements.map((multiRoomElem) => thn.parseNumber(multiRoomElem.lastChild.querySelector('[id*=mbprice_]')?.textContent)).filter(Boolean);
            widgetData.price = prices.sort((curr, next) => curr - next)[0];
            const roomsDispoElems = [...document.querySelectorAll('.top-filter-select-party-rooms .top-filter-select-party-room-inputs')];
            widgetData.roomsDispo = roomsDispoElems.map((dispoEleme) => {
                const adultsNum = thn.parseNumber(dispoEleme.querySelector('.input-adults')?.value) || 2;
                const childrenNum = thn.parseNumber(dispoEleme.querySelector('.input-children')?.value) || 0;
                const parsedChildrenAges = [...dispoEleme.querySelectorAll('.top-filter-select-party-ages-selects option[selected]')]
                    .map((ageElem) => thn.parseNumber(ageElem.textContent));
                return {
                    adults: adultsNum,
                    children: childrenNum,
                    childrenAges: parsedChildrenAges,
                };
            });
        }
        else { //* (Single Room Occupancy)
            //* Guests
            widgetData.adults = thn.dataLayerHelper.get('numAdultsSearch') || 2; // By default
            widgetData.children = 0;
            const roomsElem = [...document.querySelectorAll('div[id^="rate_"], div[id^="room_"], .card-grid--rate-primary')];
            roomsElem?.forEach(function (room, _iroom) {
                // Get the selected days which has a 'bar' above
                const daysSelected = [];
                room.querySelectorAll('.dateholder').forEach(function (day, _iday) {
                    if (day.classList?.value?.includes('dhsel')) {
                        daysSelected.push(_iday);
                    }
                });
                room.querySelectorAll('tr[id^="mdarateroom"], table.fwtable > tbody > tr:nth-child(n+2), .mda-table__data-row').forEach(function (rateEl) {
                    // If the rate doesn't have a "Book Now" button, the rate is not avaible (requires min stays, not avaible...)
                    if (rateEl?.querySelector('.bookbutton, .book-now-button')) {
                        let ratePerNightCounter = 0; // Counter to ensure that each rate has a price for every night
                        let rateTotalPrice = 0;
                        // Case 1: Total Price
                        rateEl?.querySelectorAll('.sdapricebox, .sdacontainer .price.hastooltip span[id^=mbprice_], .mda-table__total-price .display-price').forEach(function (priceEl) {
                            const price = thn.parseNumber(priceEl?.textContent);
                            if (price) {
                                rateTotalPrice = price;
                                // This case only has 1 entry so set the nights right away
                                ratePerNightCounter = widgetData.nights;
                            }
                        });
                        if (!rateTotalPrice) {
                            // Case 2: Grid (Rate view & Room view)
                            rateEl.querySelectorAll('.mdatd').forEach(function (priceBox, _ipriceBox) {
                                if (daysSelected.length && daysSelected.indexOf(_ipriceBox) > -1) {
                                    const price = thn.parseNumber(priceBox.querySelector('.curdis:last-of-type')?.textContent);
                                    if (price) {
                                        rateTotalPrice += price;
                                        ratePerNightCounter += 1;
                                    }
                                    else {
                                        // Try to get the price from the JSON rel attribute
                                        try {
                                            const priceJson = parseInt(JSON.parse(priceBox.querySelector('.mda[rel]')?.getAttribute('rel')?.price), 10);
                                            if (priceJson) {
                                                rateTotalPrice += priceJson;
                                                ratePerNightCounter += 1;
                                            }
                                        }
                                        catch (e) { }
                                    }
                                }
                            });
                        }
                        if (rateTotalPrice && ratePerNightCounter === widgetData.nights) {
                            const roomGuestsRaw = room.querySelector('.sda-party-prompt')?.textContent?.split(',') || room.querySelector('.price-header p')?.childNodes[2]?.textContent?.split(',');
                            if (!thn.empty(roomGuestsRaw)) {
                                widgetData.adults = thn.parseNumber(roomGuestsRaw[0] || '1');
                                widgetData.children = thn.parseNumber(roomGuestsRaw[1] || '0');
                            }
                            else {
                                // Get the room adults
                                let adultsFilter = rateEl?.getAttribute('data-filter');
                                adultsFilter = adultsFilter && adultsFilter.fullocc;
                                adultsFilter = adultsFilter && Math.max(...adultsFilter);
                                if (!adultsFilter) {
                                    let occ = rateEl?.querySelector('[id^="roomocc"]')?.getAttribute('data-tooltip');
                                    occ = occ && occ.split(',');
                                    adultsFilter = occ && occ.length === 2 && thn.parseNumber(occ[1]);
                                }
                                widgetData.adults = adultsFilter || 1;
                            }
                            /* best_room = room;
                                              best_rate = rate; */
                            // this rate has prices for every night
                            if (!widgetData.price || widgetData.price > rateTotalPrice) {
                                widgetData.price = rateTotalPrice;
                            }
                        }
                    }
                });
                widgetData.guests = widgetData.adults + widgetData.children;
            });
        }
        if (widgetData.price) {
            // Price per night
            if (widgetData.price && widgetData.dateBegin && widgetData.dateEnd) {
                widgetData.price = Math.round((widgetData.price / widgetData.nights) * 100) / 100;
            }
            // ** Special offers applied **
            const specialOffers = document.querySelector('.top-filter-select-rategroups input:checked + span, [class*="page-rate"]');
            // ** Room Rates **
            // If we detect that the user are filtering the rooms, we should flag the seach as special rate
            // because we can't ensure that the price we¡re seeying is the BAT one
            const roomFilter = document.querySelector('.top-filter-select-roomgroups input:checked + span');
            // ** Room / Package filter in the URL **
            // if we match "rategroup" in the pathname, we're seeying special offers/packages (usually from campaings)
            // ex: https://ag.avvio.com/convert/site/Dalmahoy Hotel and Country Club/en/results/rategroup/158329674455927/golf-breaks.php
            const roomFilterUrl = !!window.location.pathname.match(/\/rategroup\/\d+\//);
            // Room filter can be defined on the search part of the URL, if this param has value, we should flag this search as special rate
            const roomFilterSearchParam = !!thn.parseUrlParameter('roomcode');
            let viewType;
            if (thn.data.accountUserId === 1036297) {
                // When coming come from Rooms page of the hotel, you have chosen one specific room and only see the rates
                // for that room, while there could be cheaper rates in other rooms, so we flag it as priceSpecial.
                // The parameter value when we come normaly to R&R is 'rateroom' instead of 'roomrate'
                viewType = thn.parseUrlParameter('viewtype') === 'roomrate';
            }
            widgetData.priceSpecial = (specialOffers || roomFilter || roomFilterUrl || viewType || roomFilterSearchParam) ? 1 : 0;
        }
        else if (!!document.querySelector('#noavail') || thn.isVisible(document.querySelector('#placeholder_noresult'))) {
            // No availability
            widgetData.noRooms = true;
            return widgetData;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_145
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        if (!$) {
            return widgetData;
        }
        // ID
        widgetData.bookingId = thn.dataLayerHelper.get('bookingRef')
            || $('#myreservation').find('.header2').text();
        // Dates
        widgetData.dateBegin = (thn.dataLayerHelper.get('checkinDate') || '').replace(/-/g, '/');
        widgetData.dateEnd = (thn.dataLayerHelper.get('checkoutDate') || '').replace(/-/g, '/');
        if (!widgetData.dateBegin || !widgetData.dateEnd) { // DOM Alterative
            let dates = $('.occupancytable tbody tr td:eq(1)').find('.form-row:eq(1)').text();
            if (dates) {
                dates = dates.split(' - ');
                // US/EU date format
                const dateFormat = (thn.inArray(thn.data.propertyId, [1015727, 1013758])) ? '$3/$1/$2' : '$3/$2/$1';
                if (dates && dates.length >= 2) {
                    /* Dates are given in two formats: 03-Dec-2018 or 12/03/2018 */
                    if (dates[0].match(/(\d{1,2}\D+\d{1,2}\D+\d{4})/)) {
                        widgetData.dateBegin = dates[0].replace(/(\d{1,2})\D+(\d{1,2})\D+(\d{4})/, dateFormat);
                    }
                    else {
                        widgetData.dateBegin = translateDate(dates[0], thn.data.language);
                    }
                    if (dates[1].match(/(\d{1,2}\D+\d{1,2}\D+\d{4})/)) {
                        widgetData.dateEnd = dates[1].replace(/(\d{1,2})\D+(\d{1,2})\D+(\d{4})/, dateFormat);
                    }
                    else {
                        widgetData.dateEnd = translateDate(dates[1], thn.data.language);
                    }
                }
            }
        }
        // Price & Currency
        widgetData.price = parseFloat(thn.dataLayerHelper.get('transactionTotal'));
        widgetData.currency = thn.getCurrencyCode(thn.dataLayerHelper.get('currency'));
        if (!widgetData.currency || !widgetData.price) { // DOM Alternative
            const priceText = $('.occupancytable').find('tr[class=mainhead]').find('td[class=text-right] .header4').text();
            if (priceText) {
                widgetData.currency = thn.getCurrencyCode((priceText.match(/[^\d\s,.]+/) || [])[0]);
                widgetData.price = thn.parseNumber(priceText);
            }
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_145
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = !!(thn.parseUrlParameter('pc')
            // if the code was applied inside R&R, the URL var won't be added
            || ((document.querySelector('.top-filter-promocode-text') || {}).textContent || '').match(/applied/i)
            || thn.isVisible(document.querySelector('#promoCodeButton .code_applied')));
        if (promocode) {
            // the actual promocode is encoded, return a dummy promocode string instead.
            ctx.promocode = document.querySelector('.text-field__input')?.value || '__unknown__';
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
